import { useEffect, useState } from "react"
import { StorefrontApiClient, createStorefrontApiClient } from "@shopify/storefront-api-client";

const configDomId = 'storefront-api-config';

const useStorefrontApi = (gqlQuery: string, variables = {}) => {
  const [client, setClient] = useState<StorefrontApiClient>();
  const [storefrontData, setStorefrontData] = useState();
  const [isFetchingStorefront, setIsFetchingStorefront] = useState(true);

  if (!client) {
    const configEl = document.getElementById(configDomId);
    const storeDomain = configEl?.dataset?.domain;
    const apiVersion = '2025-01';
    const publicAccessToken = configEl?.dataset?.token;

    if (storeDomain && apiVersion && publicAccessToken) {
      const shopifyClient = createStorefrontApiClient({storeDomain, apiVersion, publicAccessToken});
      setClient(shopifyClient);
    } else {
      console.error('error: ', apiVersion, storeDomain, publicAccessToken);
      console.error('The shopify storefront api client could not be created due to missing environment variables');
    }
  }

  useEffect(() => {
    const queryStorefront = async () => {
      if (!client) return;

      try {
        const { data, errors } = await client.request(gqlQuery, { variables });
        setStorefrontData(data);
        
        if (errors) {
          console.error(errors, errors?.graphQLErrors)
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsFetchingStorefront(false);
      }
    }

    queryStorefront();
  }, []);

  return { storefrontData, isFetchingStorefront };
}

export default useStorefrontApi;